import { useDispatch } from "react-redux";
import { Action, Dispatch } from "redux";

type AppDispatch = Dispatch<Action>; 
export const useAppDispatch = () => useDispatch<AppDispatch>();